import {api} from "../utils/api";
import {message, notification} from "antd";
import {API_URL} from "../utils/constants";


export const rootAction = (method, url, data, actions, headers, timeout) => dispatch => {
    dispatch({
        type: actions.request
    })

    api.request({method, url, data, headers, timeout})
      .then((res) => {
          console.log("res", res && res.data && res.data.code)
          if (res && res.data && res.data.code < 200 || res && res.data && res.data.code > 202) {
              dispatch({
                  type: actions.failure,
                  payload: null,
                  error: res.data.message
              });
              notification.open({
                  message: 'Код: ' + (res.data.code),
                  description: `${res.data.message} `,
                  placement: 'bottomRight',
                  duration: 6
              });
          } else {
              dispatch({
                  type: actions.success,
                  payload: res.data ? res.data : null
              })
          }

      })
      .catch(err => {
          console.log(err)
          if (err.response) {
              dispatch({
                  type: actions.failure,
                  payload: null,
                  error: err.response.data
              });
              notification.open({
                  message: 'Код: ' + (err.response.data.status ? err.response.data.status : err.response.data.code),
                  description: `${err.response.data.error} || ${err.response.data.message}`,
                  placement: 'bottomRight',
                  duration: 6
              });
          } else if (err.code === 'ECONNABORTED') {
              err.code = 'Перевищений ліміт очікування';
              err.message = 'Не вдалось обробити запит ' + url;
              notification.open({
                  message: err.code,
                  description: err.message,
                  placement: 'bottomRight',
                  duration: 6
              });
              dispatch({
                  type: actions.failure,
                  payload: null,
                  error: err
              })
          } else {
              dispatch({
                  type: actions.failure,
                  payload: null,
                  error: err
              })

              notification.open({
                  message: "Помилка мережевого з'єднання",
                  description: err.message +" " + url,
                  placement: 'bottomRight',
                  duration: 6
              });
          }
      })
}

export const rootActionDownload = (extra, method, url, fileName, actions, headers) => dispatch => {
console.log("rootActionDownload")
    dispatch({
        type: actions.request
    })

    api.request({
        method: method,
        url: url,
        data: extra,
        headers: {
            'Content-Type': 'application/json'
        },
        // headers: headers,
        responseType: 'blob'
    }).then((response) => {

        console.log("RES",response )

        dispatch({
            type: actions.success
        })
        const contentType = response.headers['content-type']

        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(new Blob([response.data], {type: contentType}), fileName);
        }
        else {
            console.log("INSIDE")
            const url = window.URL.createObjectURL(new Blob([response.data], {type: contentType}, fileName));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        }

    }).catch((err) => {
        console.log("err",err )
        dispatch({
            type: actions.failure,
            // error: err.response.data
        })
        message.config({
            top: 400,
            duration: 2,
        });
        // const reader = new FileReader();
        // reader.readAsText(err.response.data);
        // reader.addEventListener('loadend', () => {
        //     const result = JSON.parse(reader.result)
        //     message.error(<span>Серверна помилка:{result.data}</span>)
        // });
        // console.log("err", err)
        // console.log("error message",  err.message)
        // console.log("error data",  err.response.data )
        // console.log("error response",  err.response)
    });
}